import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LoadingSpinner from './LoadingSpinner';


const MegaPokemon = () => {
    const [megaPokemon, setMegaPokemon] = useState([]);
    const [selectedPokemon, setSelectedPokemon] = useState(null);
    const [showShiny, setShowShiny] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPokemon = async () => {
            try {
                const res = await axios.get('https://tyradex.vercel.app/api/v1/pokemon');
                console.log('API response:', res.data); 
                setLoading(false);

                const megaList = res.data.filter(pokemon => {
                    if (pokemon.evolution && pokemon.evolution.mega && pokemon.evolution.mega.length > 0) {
                        console.log('Filtered Pokemon:', pokemon); 
                        return true;
                    }
                    return false;
                });

                setMegaPokemon(megaList);
                console.log('Mega Pokemon List:', megaList); 
            } catch (error) {
                console.error('Error fetching the Pokémon data:', error);
            }
        };

        fetchPokemon();
    }, []);

    const handleImageClick = (pokemon) => {
        setSelectedPokemon(pokemon);
        setShowShiny(false); 
    };

    const handleCloseModal = () => {
        setSelectedPokemon(null);
    };

    const toggleShiny = () => {
        setShowShiny(!showShiny);
    };

    if (megaPokemon.length === 0) return <LoadingSpinner/>;

    return (
        <div className="gmaxpokemon">
            <ul>
                {megaPokemon.map(pokemon => (
                    <li key={pokemon.pokedex_id} className="pokemoncard">
                        <img 
                            src={pokemon.evolution.mega[0].sprites.regular} 
                            alt={pokemon.name.fr} 
                        />
                        <div className="infos" onClick={() => handleImageClick(pokemon)}>
                            <h2>{pokemon.name.fr} Mega</h2>
                        </div>
                    </li>
                ))}
            </ul>

            {selectedPokemon && (
                <div className="modal" onClick={handleCloseModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <img 
                            src={showShiny ? selectedPokemon.evolution.mega[0].sprites.shiny : selectedPokemon.evolution.mega[0].sprites.regular} 
                            alt={selectedPokemon.name.fr} 
                        />
                        <button onClick={toggleShiny}>
                            {showShiny ? 'Regular' : 'Shiny'}
                        </button>
                        <button onClick={handleCloseModal}>Fermer</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MegaPokemon;


